import Header from '@/pages/layout/components/FrontHeader';
import Footer from '@/common/footer/Footer';
import style from '@/pages/layout/style/FrontLayout.module.less';
import { useUserInfo } from '@/hooks/hooks';
import IconFont from '@/common/IconFont';
import FrontMenu from '@/pages/layout/components/FrontMenu';
import { useAliveController } from 'react-activation';
import { useEffect } from 'react';

const Portal = () => {

  const state = useUserInfo();
  const { drop, getCachingNodes } = useAliveController();
  useEffect(() => {
    const cacheList = getCachingNodes();
    cacheList.forEach(i => {
      drop(String(i.name));
    });
  }, []);

  return (
    <>
      <Header></Header>
      <div className={style.portalContent}>
        <div>
          <div>
            <div>
              <img src={require('@/assets/imgs/portal-head.png')} alt="" />
              <div>
                <div>{state.name}, 欢迎您！</div>
                <div>
                  { state.userType === 'EDU' ? '江阴市教育局': state.schools?.map(i => i.name).toString() }
                </div>
              </div>
            </div>
            <div>
              <span>个人中心</span>
              <IconFont type="icon-shouqi"></IconFont>
            </div>
          </div>
        </div>
        {/* 菜单 */}
        <FrontMenu userType={state.userType} />
      </div>
      <Footer className={style.footer}></Footer>
    </>
  );
};

export default Portal;